import { Route } from '@angular/router';

export class AppRouterHelper {
    static getLegacyUrls(): Route[] {
        return [
            ...AppRouterHelper.getStrainLegacyUrls(),
            ...AppRouterHelper.getAimLegacyUrls(),
            ...AppRouterHelper.getPredefinedProbeLegacyUrls(),
        ];
    }

    private static getStrainLegacyUrls(): Route[] {
        return [
            { path: 'Strains/Default.aspx', redirectTo: 'strains/listing' },
            { path: 'Strains/StrainCopy.aspx', redirectTo: 'strains/copy' },
            ...AppRouterHelper.computeStrainDetailsLegacyUrls(),
        ];
    }

    private static computeStrainDetailsLegacyUrls(): Route[] {
        const paths = [
            {
                legacyUrl: 'Strains/Strain.aspx',
                redirectTo: 'overview',
            },
            {
                legacyUrl: 'Strains/StrainMessages.aspx',
                redirectTo: 'messages',
            },
            {
                legacyUrl: 'Strains/StrainNotes.aspx',
                redirectTo: 'notes',
            },
            {
                legacyUrl: 'Strains/StrainTranslations.aspx',
                redirectTo: 'translations',
            },
        ];

        return paths.map(path => {
            return {
                path: path.legacyUrl,
                redirectTo: ({ queryParams }) => {
                    const id = queryParams['StrainId'];
                    if (id !== undefined) {
                        return `/strains/strain/${path.redirectTo}?strainId=${id}`;
                    } else {
                        return `/strains/listing`;
                    }
                },
            };
        });
    }

    private static getAimLegacyUrls(): Route[] {
        return [
            { path: 'AssayDesign/Search.aspx', redirectTo: 'assays/listing' },
            { path: 'AssayDesign/Sequencing.aspx', redirectTo: 'assays/sequencing' },
            { path: 'AssayDesign/ProbeManufacturing.aspx', redirectTo: 'assays/probe-manufacturing' },
            { path: 'AssayDesign/Constructs.aspx', redirectTo: 'assays/constructs' },
            ...AppRouterHelper.computeAimDetailsLegacyUrls(),
            ...AppRouterHelper.computeAimConstructDetailsLegacyUrls(),
        ];
    }

    private static computeAimDetailsLegacyUrls(): Route[] {
        const paths = [
            {
                legacyUrl: 'AssayDesign/Assay.aspx',
                redirectTo: 'overview',
            },
            {
                legacyUrl: 'AssayDesign/AssayDetails.aspx',
                redirectTo: 'modify-details',
            },
            {
                legacyUrl: 'AssayDesign/AssayProbes.aspx',
                redirectTo: 'probes',
            },
            {
                legacyUrl: 'AssayDesign/AssayFiles.aspx',
                redirectTo: 'docs',
            },
            {
                legacyUrl: 'AssayDesign/AssayNotes.aspx',
                redirectTo: 'notes',
            },
            {
                legacyUrl: 'AssayDesign/AssayLog.aspx',
                redirectTo: 'log',
            },
            {
                legacyUrl: 'AssayDesign/AssayStrainInformationForm.aspx',
                redirectTo: 'sif',
            },
        ];

        return paths.map(path => {
            return {
                path: path.legacyUrl,
                redirectTo: ({ queryParams }) => {
                    const id = queryParams['AssayId'];
                    if (id !== undefined) {
                        return `/assays/assay/${path.redirectTo}?assayId=${id}`;
                    } else {
                        return `/assay/listing`;
                    }
                },
            };
        });
    }

    private static computeAimConstructDetailsLegacyUrls(): Route[] {
        const paths = [
            {
                legacyUrl: 'AssayDesign/Construct.aspx',
                redirectTo: 'overview',
            },
            {
                legacyUrl: 'AssayDesign/ConstructStrains.aspx',
                redirectTo: 'strains',
            },
        ];

        return paths.map(path => {
            return {
                path: path.legacyUrl,
                redirectTo: ({ queryParams }) => {
                    const id = queryParams['ConstructId'];
                    if (id !== undefined) {
                        return `/assays/construct/${path.redirectTo}?constructId=${id}`;
                    } else {
                        return `/assays/constructs`;
                    }
                },
            };
        });
    }

    private static getPredefinedProbeLegacyUrls(): Route[] {
        return [
            { path: 'PredefinedProbes/Default.aspx', redirectTo: 'probes/listing' },
            { path: 'PredefinedProbes/AbiOrderFileImport.aspx', redirectTo: 'probes/abi-file-import' },
            { path: 'PredefinedProbes/Manufacturing.aspx', redirectTo: 'probes/probe-manufacturing' },
            { path: 'PredefinedProbes/IncompatibleProbes.aspx', redirectTo: 'probes/incompatible-probes' },
            ...AppRouterHelper.computePredefinedProbeDetailsLegacyUrls(),
        ];
    }

    private static computePredefinedProbeDetailsLegacyUrls(): Route[] {
        const paths = [
            {
                legacyUrl: 'PredefinedProbes/PredefinedProbe.aspx',
                redirectTo: 'overview',
            },
            {
                legacyUrl: 'PredefinedProbes/PredefinedProbeModify.aspx',
                redirectTo: 'modify-details',
            },
            {
                legacyUrl: 'PredefinedProbes/PredefinedProbeOrderHistory.aspx',
                redirectTo: 'order-history',
            },
            {
                legacyUrl: 'PredefinedProbes/PredefinedProbeRedesign.aspx',
                redirectTo: 'redesign',
            },
            {
                legacyUrl: 'PredefinedProbes/PredefinedProbeRetests.aspx',
                redirectTo: 'schedule-retests',
            },
            {
                legacyUrl: 'PredefinedProbes/PredefinedProbeSequencing.aspx',
                redirectTo: 'sequencing',
            },
            {
                legacyUrl: 'PredefinedProbes/PredefinedProbeStrains.aspx',
                redirectTo: 'strains',
            },
        ];

        return paths.map(path => {
            return {
                path: path.legacyUrl,
                redirectTo: ({ queryParams }) => {
                    const id = queryParams['PredefinedProbeId'];
                    if (id !== undefined) {
                        return `/probes/probe/${path.redirectTo}?predefinedProbeId=${id}`;
                    } else {
                        return `/probes/listing`;
                    }
                },
            };
        });
    }
}
